(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .config(config);

    config.$inject = ['$urlRouterProvider'];

    /* @ngInject */
    function config($urlRouterProvider) {
        $urlRouterProvider
            .when('/', ['$state', goHomePage]);
           // .when('/profile', ['$state', '$match', 'Authenticate', goHomePage]);

        function goHomePage($state) {
            $state.go('project')
        }
    }
})();

